module.exports = __webpack_public_path__ + "static/media/schlegel_train_03.defa56d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/schlegel_train_03.jpg
// module id = 388
// module chunks = 0